import React from "react";
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from "react-router";
import { getCurrentLanguageFromUrl } from "../../Utils/urlLanguageUtils";

export interface LanguageLinkProps extends Omit<ReactRouterLinkProps, "to"> {
  to: string;
  children?: React.ReactNode;
}

export const Link: React.FC<LanguageLinkProps> = ({ to, children, ...props }) => {
  const currentLanguage = getCurrentLanguageFromUrl();

    
  if (to.startsWith("/fa/") || to.startsWith("/en/")) {
    return (
      <ReactRouterLink to={to} {...props}>
        {children}
      </ReactRouterLink>
    );
  }

  // For home page
  if (to === "/") {
    // For Farsi (default language), no prefix needed
    if (currentLanguage === "fa") {
      return (
        <ReactRouterLink to="/" {...props}>
          {children}
        </ReactRouterLink>
      );
    } else {
      return (
        <ReactRouterLink to={`/${currentLanguage}`} {...props}>
          {children}
        </ReactRouterLink>
      );
    }
  }

  // For Farsi (default language), don't add prefix
  if (currentLanguage === "fa") {
    return (
      <ReactRouterLink to={to} {...props}>
        {children}
      </ReactRouterLink>
    );
  } else {
    // For other languages, add prefix
    const pathWithLanguage = `/${currentLanguage}${to}`;
    return (
      <ReactRouterLink to={pathWithLanguage} {...props}>
        {children}
      </ReactRouterLink>
    );
  }
};
